<div class="pop-bg">
</div>

<div class="pop-position" style="bottom: 300px !important;">

    <!-- <div class="modal fade add-denial-code in" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel">

                        <div class="modal-dialog modal-sm  modal-bottom dark popup-width-globle drnial-code-p" role="document">
                            <div class="modal-content white" style="width: 100%;"> -->

    <div class="row col-md-12 p-0 grey header-popup-box">
        <span class="col-md-10 col-sm-10 p-0">
            <div class="heading-panel">
                <span class="text-sm text-ellipsis heading-txt flex ml-10">Provider Signature</span>
            </div>
        </span>
        <span class="pull-right text-right col-md-2 col-sm-2 pv-10 cursor" (click)="closeModel()">
            <i class="fa fa-times" aria-hidden="true"></i>
        </span>
    </div>
    <div class="col-md-12 p-0 mt-10 row">
        <div class="col-md-12 col-sm-12 col-xs-12 mb-10 mt-10">
            <div class="col-md-12 col-sm-12 col-xs-12 p-0">
                <label class="w-100">Provider Signature:*</label>
                <span class="form-group  mt-10">
                    <form class="form">
                        <div class="file-upload-wrapper inventory-provider" [attr.data-text]="Filename">
                            <input name="file-upload-field" (change)="OnChange($event);" onclick="this.value = null"
                                type="file" accept=".jpeg,.png," class="file-upload-field">
                        </div>
                    </form>
                </span>
                <span>
                    <button [disabled]="uploadBtnDisable" (click)="uploadSignature();"
                        class="btn pr-upl label btn-default label-info-padding label-info square-btn cursor mr-10 mt-0">
                        Upload</button>

                </span>
            </div>

        </div>


    </div>



</div>
